import type { newsApi } from 'app/src/services/welfareportal'
import { DownloadFileButton } from 'app/src/shared/components'
import { useTranslation } from 'react-i18next'

export function DownloadPdfButton(props: { newsItem: newsApi.News }) {
  const { t } = useTranslation('news')

  return (
    <DownloadFileButton
      buttonLabel={t('News.DownloadPdf')}
      downloadErrorMessage={t('News.DownloadPdfErrorMessage')}
      fileLink={props.newsItem.pdfLink!}
      fileName={`News_${props.newsItem.date}_${props.newsItem.id}.pdf`}
    />
  )
}
